export default __webpack_public_path__ + "552e5755e5507674d9d89d3a300d4fbe.png";